module.exports = __webpack_public_path__ + "img/52.553a5fbd.png";